import { useMemo } from 'react';
import memoizeOne from 'memoize-one';
import { useProjectReportsSidebarConnectNavigation } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';
import { useRouter } from '@atlassian/react-resource-router';
import { findItemAndStack } from '../../common/utils/find-item-stack/index.tsx';
import { transformLinkV4 } from '../../common/utils/transform-link/index.tsx';
import type { UseProjectReportsConnectItemsReturn } from './types.tsx';

const findItemAndStackMemo = memoizeOne(findItemAndStack);

export const useProjectReportsConnectItems = (): UseProjectReportsConnectItemsReturn => {
	const [{ route, location }] = useRouter();
	const { data, loading, error } = useProjectReportsSidebarConnectNavigation();

	const items = useMemo(
		() => (data != null ? data.map(transformLinkV4).filter(Boolean) : []),
		[data],
	);
	const found = useMemo(
		() => route && items && findItemAndStackMemo(items, route.name, location, ['reports']),
		[items, route, location],
	);
	return {
		data: items,
		error,
		loading,
		selected: found && found.selected,
		stack: found && found.stack,
	};
};
